import request from './request';

// 提交实名认证
export function submitRealname(data) {
  return request.post('/api/realname/submit', data);
}

// 获取实名 / 青少年模式状态
export function getRealnameStatus() {
  return request.get('/api/realname/status');
}

// 设置青少年模式开关（关闭时需传家长密码 pwd）
export function setMinorMode(on, pwd) {
  return request.post('/api/realname/setMinorMode', { on: on ? 1 : 0, pwd: pwd || '' });
}

// 青少年模式使用时长心跳
export function minorHeartbeat(seconds) {
  return request.post('/api/realname/heartbeat', { seconds: seconds || 60 });
}

// 设置 / 修改家长密码（独立密码）
export function setParentPwd(pwd, oldPwd) {
  return request.post('/api/realname/setParentPwd', { pwd, old_pwd: oldPwd || '' });
}

// 验证家长密码
export function verifyParentPwd(pwd) {
  return request.post('/api/realname/verifyParentPwd', { pwd });
}

// 修改青少年模式每日使用时长（需家长密码）
export function setDailyLimit(limitMin, pwd) {
  return request.post('/api/realname/setDailyLimit', { limit_min: limitMin, pwd });
}

// 家长密码临时授权：每日时长用完后临时使用 30 分钟
// - 已设家长密码：传 pwd 校验
// - 未设家长密码：传 newPwd 首次设置并立即解锁
export function grantTempUse(pwd, newPwd) {
  return request.post('/api/realname/grantTempUse', { pwd: pwd || '', new_pwd: newPwd || '' });
}
